export const UtilsHelper = {
	deleteEmptyPropsFromObject(obj: any) {
		return Object.keys(obj).forEach((key: any) => this.deleteEmptyProp(obj, key));
	},

	deleteEmptyProp(obj: any, key: string | number) {
		return (obj[key] === null || this.isEmptyArray(obj[key]) || this.isEmptyObject(obj[key])) && delete obj[key];
	},

	isEmptyArray(value: any) {
		return value && Array.isArray(value) && value.length === 0;
	},

	isEmptyObject(value: any) {
		return value && !this.isPrimitive(value) && Object.entries(value).length === 0;
	},

	isPrimitive(arg: any) {
		const type = typeof arg;
		return arg == null || (type != 'object' && type != 'function');
	},
};
